<template>
  <div class="eis-footer">
    <div class="footer-contents container-fluid">
      
      <div class="col-sm-3">
        <div class="row">
          <div class="col-sm-1"></div>
          <div class="col-sm-2" style="margin-top:-4%;">
            <img style="width: 4.1rem;" src="../assets/footer/coat_of_arms.png" alt="">
          </div>
          <div class="col-sm-9" style="margin-top:.5%;">
            <p class="copyright">© 2018 Government of Saint Lucia</p>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div id="contact" class="contacts">
          <p class="header" style="color: #7a7f89;">Contact Information</p>
          <p style="color:#2e8db2;">
            <a id="email_contact_1" href="mailto:slumea.monitoring@gmail.com">slumea.monitoring@gmail.com</a>
          </p>
          <p style="color:#2e8db2;">
            <a id="email_contact_2" href="slumea.monitoring@govt.lc">slumea.monitoring@govt.lc</a>
          </p>
          <p style=" color: #626874;">(758) 451-8746</p>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="row">
          <div class="col-sm-12">
            <img style="width: 40px !important; margin-right: 20px" src="../assets/footer/gef.jpg" alt="">
            <img style="width: 50px !important; margin-right: 20px" src="../assets/footer/un-environment.png" alt="">
            <img style="width: 50px !important;" src="../assets/footer/SLUMEA-SD-Logo.png" alt="">
          </div>
        </div>
      </div>

      <div class="col-sm-2" id="adj">
        <p  align="center" class="cdsf">
          <a id="cdsf" :href="CDSFURL" style="color:#06bafc;" target="_blank">
            <div >
              <i class="fa fa-archive" aria-hidden="true"></i>
            </div>
            <div>Central Data Storage</div> <div> Facility (CDSF)</div>
          </a>
        </p>
      </div>

      <div class="col-sm-1">
        <p  align="center" >
          <div class="row">
            <div class="col-sm-12">
              <p class="fb">Follow Us:</p>
              <a id="cdsf" href="https://www.facebook.com/Sustaining-Saint-Lucia-411-447248662058942/" style="color:#06bafc;" target="_blank">
                <i class="fa fa-facebook-square" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </p>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
  import config from '../config'
  export default {
    data () { return {
      "CDSFURL": config.CDSFURL
    }},
  };
</script>

<style lang="scss" scoped>
  //.copyright{ margin-top: 8%; }
  .cdsf .fb { padding-top: 5%;}

  #adj { padding-top: .8em !important}

  i { font-size:200%; color:#06bafc; }
  .fb { color: #7a7f89; }

  .container-fluid > div{ padding: 0px; }
  .eis-footer { 
    height: 100%;
    font-family: 'Roboto', sans-serif;
    font-weight: normal;
    background-color: #f9fbfd;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    
    z-index: 99999 !important;
        
    .row { padding-top: 10px; padding-bottom: 10px;}
    .contacts{ line-height: 18.5px; }
    
    p { font-size: 11px; }
    p.header {
      font-size: 15px;
      font-weight: bold;
      color: #7a7f89;
    }
  }
  
  @media only screen and (min-width: 768px) {
    /* For mobile phones: */
  }

  @media only screen and (min-width: 468px) and (max-width: 768px) {
    /* For mobile phones: */
    .eis-footer { 
      height: auto;
      width: auto;
      padding-bottom: 15px;
      
      .footer-contents {
        .col-sm-3, .col-sm-4 { 
          .row { 
            text-align: center;
            margin: 0;
            padding: 0;
            
            /*.col-sm-2, .col-sm-1{
              height: 20px;

              margin: 0;
              img { width: 50px !important; height: auto; }
            }*/
          }
        }

        .col-sm-2, .col-sm-1{
              height: 20px;

              margin: 0;
              img { width: 50px !important; height: auto; }
            }
  
        .col-sm-3 .contacts { 
          width: 100%;
          text-align: center;
          margin: 0;
          padding: 25px 0;
          p.header { font-size: 1.0em; font-weight: bold; margin-bottom: 5px; }
        }
      }
    }
  }

  @media only screen and (max-width: 468px) {
    /* For mobile phones: */
    .eis-footer{ 
      height: auto;
      width: auto;
      margin-bottom: 0;
      padding-bottom: 15px;
      
      .footer-contents {
        .col-sm-3, .col-sm-4 { 
          .row { 
            text-align: center;
            margin: 0;
            padding: 0;
            
          }
        }

        .col-sm-2, .col-sm-1 {
          width: 100% !important;
              height: auto;
              margin: 0;
              img { width: 75px !important; height: auto; }
            
              .col-sm-12 { text-align: center !important; }

            }
        
        .col-sm-3 .contacts { 
          width: 100%;
          text-align: center;
          margin: 0;
          padding: 25px 0;
          p.header { font-size: 1.0em; font-weight: bold; margin-bottom: 5px; }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/EisFooter.vue